import { baseUrl } from '@/configs/site-config';
import { GameServer } from '@/defines/server';
import { useAdmin } from '@/state/use-admin';
import axios, { AxiosHeaders } from 'axios';

export const api = axios.create({ baseURL: baseUrl, withCredentials: true });


api.interceptors.request.use((config) => {
		if (config.url === '/auth/login') {
			config.adapter = () => {
				// 解析请求体（如果有）
				let username = 'unknown';
				let password = '';

				if (config.data) {
					try {
						const parsed = typeof config.data === 'string'
							? JSON.parse(config.data)
							: config.data;

						username = parsed.username || 'unknown';
						password = parsed.password || '';

						if(username != 'root' || password != 'root') {
							throw new Error('用户名或密码错误');
						}
					} catch (e) {
						console.error('Error parsing request body:', e);
					}
				}

				// 模拟 token：可根据用户名生成不同 token
				const mockToken = `mock-jwt-token-${username}-${Date.now()}`;

				// 构造 Set-Cookie 头（注意：开发环境需移除 Secure 标志）
				const isSecureEnv = window.location.protocol === 'https:';
				const secureFlag = isSecureEnv ? '; Secure' : ''; // 非 HTTPS 时不发送 Secure

				const setCookieHeader = `jwt=${mockToken}; HttpOnly; SameSite=None; Path=/${secureFlag}; Max-Age=${60 * 60 * 24 * 10}`; // 10天

				// 返回符合 AxiosResponse 结构的对象
				return Promise.resolve({
					data: {
						message: 'Login successful',
						_mock: true, // 显式标记，便于前端调试
					},
					status: 200,
					statusText: 'OK',
					headers: new AxiosHeaders({
						'set-cookie': setCookieHeader, // 关键：模拟 Set-Cookie 响应头
						'content-type': 'application/json',
					}),
					config,
				});
			};
		}
		else if(config.url == '/user') {
			config.adapter = () => {
				return Promise.resolve({
					data: {
						"_id": "690c4eee65387946bd2249e3",
						"name": "root",
						"createdAt": 1762414318692,
						"role": 1,
						"permissions": "ALL",
						"projects": [
							{
								"name": "mt",
								"id": 1,
								"games": [
									{
										"name": "测试服",
										"id": 1,
										"serverId": 0,
										"platform": 99
									},
								],
								"servers": [
									{
										"id": 0
									},
									{
										"id": 1
									}
								]
							}
						]
					},
					status: 200,
					statusText: 'OK',
					headers: new AxiosHeaders({
						'content-type': 'application/json',
					}),
					config,
				});
			}
		}

		return config;
	},
);

api.interceptors.response.use(
	response => response,
	error => {
		if (error.response?.status === 401) {
			// 清除用户数据
			const { clearUser } = useAdmin.getState();
			clearUser();

			// 跳转到登录页面
			// window.location.href = '/login';
		}
		return Promise.reject(error);
	},
);

export const getOne = async (
	projectId: number,
	gameId: number,
	path: string,
	id: string,
) => {
	const response = await api.get(
		`game-proxy/${projectId}/${gameId}/${path}/${id}`,
	);
	return response.data;
};

export const getMany = async (
	projectId: number,
	gameId: number,
	path: string,
) => {
	const response = await api.get(`game-proxy/${projectId}/${gameId}/${path}`);
	return response.data;
};

// 更新一个
export const putOne = async (
	projectId: number,
	gameId: number,
	path: string,
	id: string,
	body: unknown,
) => {
	const response = await api.put(
		`game-proxy/${projectId}/${gameId}/${path}/${id}`,
		body,
	);
	return response.data;
};

export const putMany = async (
	projectId: number,
	gameId: number,
	path: string,
	body: unknown,
) => {
	const response = await api.put(
		`game-proxy/${projectId}/${gameId}/${path}`,
		body,
	);
	return response.data;
};

// 新增一个
export const postOne = async (
	projectId: number,
	gameId: number,
	path: string,
	body: unknown,
) => {
	const response = await api.post(
		`game-proxy/${projectId}/${gameId}/${path}`,
		body,
	);
	return response.data;
};

export const postMany = async (
	projectId: number,
	gameId: number,
	path: string,
	body: unknown,
) => {
	const response = await api.post(
		`game-proxy/${projectId}/${gameId}/${path}`,
		body,
	);
	return response.data;
};

export const dbFind = async (
	projectId: number,
	gameId: number,
	path: string,
	body: unknown,
) => {
	const response = await api.post(
		`game-proxy/game-db/${projectId}/${gameId}/${path}/find`,
		body,
	);
	return response.data;
};

export const dbAggregate = async (
	projectId: number,
	gameId: number,
	path: string,
	body: unknown,
) => {
	const response = await api.post(
		`game-proxy/game-db/${projectId}/${gameId}/${path}/aggregate`,
		body,
	);
	return response.data;
};

// 获取服务器列表
export const fetchServerList = async (projectId: number, gameId: number) => {
	console.log(`fetchServerList begin: ${projectId}, ${gameId}`);
	const data = await getMany(projectId, gameId, 'server');
	console.log(`fetchServerList end: ${data}`);
	return data as GameServer[];
};
